import { render, staticRenderFns } from "./TiptapDropdownButton.vue?vue&type=template&id=5c1f8acb"
import script from "./TiptapDropdownButton.vue?vue&type=script&lang=ts"
export * from "./TiptapDropdownButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports